var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('SearchObject', {
    ref: "search",
    attrs: {
      "additional-params": Object.assign({
        ordering: '-main,name',
        archived: false
      }, _vm.additionalParams),
      "allow-create": _vm.allowCreate,
      "autofocus": _vm.autofocus,
      "base-url": _vm.baseUrl,
      "create-label": _vm.$translate('create_an_establishment'),
      "disabled": _vm.disabled,
      "error-messages": _vm.errorMessages,
      "hide-details": _vm.hideDetails,
      "item-text": _vm.itemText,
      "label": _vm.label || _vm.$translate('select_establishment'),
      "readonly": _vm.readonly,
      "required": _vm.required,
      "value": _vm.value,
      "icon": _vm.icon,
      "flat": _vm.flat,
      "outlined": _vm.outlined,
      "background-color": _vm.backgroundColor,
      "display": "establishment",
      "dense": _vm.dense
    },
    on: {
      "create": _vm.createEstablishment,
      "input": function input($event) {
        return _vm.$emit('input', $event);
      },
      "select": function select($event) {
        return _vm.$emit('select', $event);
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c('div', {
          staticClass: "d-flex align-center"
        }, [_c('span', [_vm._v(_vm._s(item.name))]), item.main ? _c('v-chip', {
          staticClass: "ml-2",
          attrs: {
            "small": "",
            "color": "primary",
            "text-color": "white"
          }
        }, [_vm._v(" " + _vm._s(_vm.$translate("main")) + " ")]) : _vm._e()], 1)];
      }
    }])
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }